<template>
  <EtaCard :show-details="Boolean(props.postcode)" />
  <StopsDescriptionCard :postcode="props.postcode" />
</template>

<script setup>
import EtaCard from '@/v2/components/cards/EtaCard.vue';
import StopsDescriptionCard from '@/v2/components/cards/StopsDescriptionCard.vue';

const props = defineProps({
  postcode: { type: String, required: false }
});
</script>

<style scoped></style>
